module.exports = __webpack_public_path__ + "img/vivobook_15.de9e7cb5.jpg";